import createWatchListEntryEuTerrorist from "./createWatchListEntryEuTerroristReducer";
import updateWatchListEntryEuTerrorist from "./updateWatchListEntryEuTerroristReducer";

export { createWatchListEntryEuTerrorist, updateWatchListEntryEuTerrorist };



// WEBPACK FOOTER //
// ./src/features/watch-list-entry-eu-terrorists/reducers/index.js